import React from 'react'
import { Heading, Box } from '@chakra-ui/core';
import Layout from '../../components/layout';

export default ({data}) => (
  <Layout>
    <Box>
      <Heading as="h1" size="xl">Live List</Heading>
      <ul>
        {data.allWpPost.edges.map( (edge) => (
          <li key={edge.node.id}>
            <a href={edge.node.uri}>
              {edge.node.title}
            </a>
          </li>
        ))}
      </ul>
    </Box>
  </Layout>
)

export const query = graphql`
  {
    allWpPost(filter: {categories: {nodes: {elemMatch: {slug: {eq: "live"}}}}}, sort: {order: DESC, fields: date}) {
      edges {
        node {
          id
          uri
          title
        }
      }
    }
  }
`

